<template>
  <el-cascader
    v-model="val"
    :options="eventAndPropOptions"
    @change="onFunnelEventAndPropChange"
    :props="{ expandTrigger: 'hover' }"
    :size="size"
    :placeholder="placeholder"
    clearable
    filterable
  ></el-cascader>
</template>

<script>
export default {
  name: 'event-and-property-selector',
  props: {
    value: {
      type: Object,
    },
    filterEvents: {
      type: Array,
    },
    filterPropertyType: {
      type: [String, Number],
    },
    allEventProperty: {
      type: Array,
      required: true,
    },
    // 是否显示为 事件1，事件2 这种
    showEventOrder: {
      type: Boolean,
      default: false,
    },
    formatOptionLabelFunc: {
      type: Function,
    },
    formatOptionValueFunc: {
      type: Function,
    },
    size: {
      type: String,
      default: 'small',
    },
    placeholder: {
      type: String,
    },
  },
  data() {
    return {
      val: [],
    };
  },
  computed: {
    eventAndPropOptions() {
      const options = [];
      let tmpAllEventProperty = this.allEventProperty;
      if (this.filterEvents) {
        const tmpList = [];
        this.filterEvents.forEach(fe => {
          const findItem = this.allEventProperty.find(a => a.eventName === fe.eventName);
          if (findItem) {
            tmpList.push(findItem);
          }
        });
        tmpAllEventProperty = tmpList;
      }
      tmpAllEventProperty.forEach((item, idx) => {
        let propList = item.propertyList;
        if (this.filterPropertyType !== undefined && this.filterPropertyType !== '' && this.filterPropertyType !== -1) {
          propList = propList.filter(p => p.propertyType === this.filterPropertyType);
        }
        options.push({
          label: this.getOptionLabelFormat(idx, item),
          value: this.getOptionValueFormat(idx, item),
          children: propList.map(p => ({ label: p.propertyDesc, value: p.propertyName })),
        });
      });
      console.log(this.filterEvents);
      return options;
    },
  },
  watch: {
    value: {
      deep: true,
      handler() {
        this.initValue();
      },
    },
  },
  mounted() {
    this.initValue();
  },
  methods: {
    initValue() {
      const v = [];
      if (this.value) {
        if (this.value.eventName !== undefined) {
          v.push(this.value.eventName);
        }
        if (this.value.propertyName !== undefined) {
          v.push(this.value.propertyName);
        }
      }
      this.val = v;
    },
    onFunnelEventAndPropChange(val) {
      console.log('val', val);
      const retVal = {
        eventName: '',
        propertyName: '',
      };
      if (val[0] !== undefined) {
        retVal.eventName = val[0];
      }
      if (val[1] !== undefined) {
        retVal.propertyName = val[1];
      }
      this.$emit('input', retVal);
      this.$emit('change', retVal);
    },
    getOptionLabelFormat(index, eventProperty) {
      if (this.showEventOrder) {
        return `事件${index + 1}`;
      }
      if (this.formatOptionLabelFunc) {
        return this.formatOptionLabelFunc({ index, eventProperty });
      }
      return eventProperty.eventShowName;
    },
    getOptionValueFormat(index, eventProperty) {
      if (this.showEventOrder) {
        return index;
      }
      if (this.formatOptionValueFunc) {
        return this.formatOptionValueFunc({ index, eventProperty });
      }
      return index;
    },
  },
};
</script>

<style scoped></style>
